import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { RootState, useAppDispatch } from '../../../redux/store/store'
import "./ItemsScheduleEmail.css"
import { useNavigate } from 'react-router-dom'
import ItemScheduleEmail from '../ItemScheduleEmail/ItemScheduleEmail'
import { DeleteScheduleEmailsThunk } from '../../../redux/slices/components/ScheduleEmails/scheduleEmailsSlice'

const ItemsScheduleEmail = () => {

    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const items = useSelector((state: RootState) => state.scheduleEmailsData.items)

    const onDelete = useCallback(
        (id: string) => {
            dispatch( DeleteScheduleEmailsThunk(id) )
        },
        [],
    )

        
    const onSave = useCallback(
        () => {
            
        },
        [],
    )
    
    const onGoEdit = useCallback(
        (id: string) => {
            navigate(`/schedule-emails/${id}`)   
        },
        [],
    )
    

    return (
        <div className="p-relative flex-1" style={{ width: "100%", minHeight: "54rem" }}>
            <div className="aux-scroll">
                {
                    items.map((item) => {
                        return (
                            <ItemScheduleEmail 
                                key={item.id}
                                item={item}
                                onDelete={onDelete}
                                onSave={onSave}
                                onPress={onGoEdit}
                            />
                        )
                    })
                }
            </div>
        </div>
    )
}

export default React.memo( ItemsScheduleEmail )